<template>
<div>
  <el-table :data="list">
    <el-table-column label="创建时间">
      <template slot-scope="scope">
        <span>{{scope.row.createTime | moment}}</span>
      </template>
    </el-table-column>
    <el-table-column label="类型">
      <template slot-scope="scope">
        {{scope.row.taskType === 0 ? '普通空投' : scope.row.taskType === 1 ? '超级合约体验金空投' : '未知'}}
      </template>
    </el-table-column>
    <el-table-column prop="description" label="描述">
    </el-table-column>
    <el-table-column prop="status" label="状态">
      <template slot-scope="scope">
        <el-tag :type="scope.row.__status.color">
          {{scope.row.__status.text}}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column label="是否发送短信">
      <template slot-scope="scope">
        <el-switch v-model="scope.row.sendMsg" active-color="#13ce66" inactive-color="#ff4949" disabled/>
      </template>
    </el-table-column>
    <!-- <el-table-column label="执行时间">
      <template slot-scope="scope">
        <span>{{scope.row.airDropTime | moment}}</span>
      </template>
    </el-table-column> -->
    <el-table-column prop="airDropTime" :formatter="dateFormat" label="执行时间"> </el-table-column>
    <el-table-column label="操作" width="200">
      <template slot-scope="scope">
      <!-- <el-button type="primary" size="small" @click="deleData(scope.row)">删除</el-button> -->
        <el-tooltip content="查看">
          <el-button type="primary" size="small" circle icon="el-icon-view" @click="viewDetail(scope.row)"></el-button>
        </el-tooltip>
        <el-button type="primary" v-show="scope.row.__status.color=='success'?false:true" size="small" @click="implement(scope.row)">执行</el-button>
      </template>
    </el-table-column>
  </el-table>
  <pagination :size="pagination.size" :page="pagination.page" :total="totalCount" @pageChanged="handleCurrentChange"/>
  <detail @refresh="handleCurrentChange({ page: 1 })"/>
  <el-dialog :visible="implementstatu" title="执行" width="400px" @close="closeDialog">
    <div class="implementdial">
      <div>
        <el-radio v-model="radiosele" :label="1">设置执行时间</el-radio>
        <el-radio v-model="radiosele" :label="2" @change="executenow">立即执行</el-radio>
      </div>
      <div>
        执行时间
        <el-date-picker  :disabled='radiosele==1?false:true'
          :picker-options="pickerOptions"
          v-model="implementTime"
          type="datetime"
          value-format="timestamp"
          placeholder="选择日期时间">
        </el-date-picker>
        
      </div>
      <div>
        <el-button type="primary" @click="save">确定</el-button>
        <el-button @click="closeDialog">取消</el-button>
      </div>
    </div>
  </el-dialog>
</div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import Pagination from '@/components/pagination';
import Detail from '../detail';
import api from '../../api.js';
import moment from 'moment'
export default {
  name: 'airdropList',
  data() {
    return {
      implementstatu:false,
      radiosele:1,
      implementTime:'',
      implementobj:{},
      pickerOptions:{
        disabledDate(time){
          // return time.getTime() < Date.now() - 8.64e6;
        }
      }
    };
  },
  created(){
    
  },
  computed: {
    ...mapState('airdrop', ['totalCount', 'pagination','activeTab']),
    ...mapGetters('airdrop', ['list'])
  },
  components: {
    Pagination,
    Detail
  },
  methods: {
    ...mapActions('airdrop', ['remove','reqList']),
    ...mapMutations('airdrop', ['setDetail']),
    dateFormat(row, column) {
          return row.airDropTime?moment(row.airDropTime).format("YYYY-MM-DD HH:mm:ss"):'';
      },
    getList(data = {}) {
      this.reqList({
        taskStatus: this.activeTab === 'all' ? '' : this.activeTab,
        ...this.pagination,
        ...data
      });
    },
    executenow(){
      this.implementTime = '';
    },
    save(){
      let data = {
        airDropTime:this.radiosele == 2?'':this.implementTime,
        sendMsg:this.implementobj.sendMsg,
        id:this.implementobj.id,
        type:this.implementobj.taskType,     
        executeJob:this.radiosele == 2?0:1
      }
      api.setExcuteTask(data).then(res=>{
        this.radiosele = 1;
        this.implementTime = '';
        this.implementstatu = false;
        this.getList({
          page: 1
        });
        this.$message.success("操作成功！")
      })
    },
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    },
    closeDialog() {
      this.radiosele = 1;
      this.implementTime = '';
      this.implementstatu = false;
    },
    deleData(data){
      this.$confirm('确认删除此空头任务？', '提示', {
          type: 'warning'
      }).then(() => {
        let obj = {id:data.id}
        api.delAirJobTask(obj).then(res=>{
          this.$message.success("删除成功");
          this.getList();
        })
      }).catch(() => {console.log(false)
      });
    },
    viewDetail(item) {
      this.setDetail(item);
    },
    implement(data){
      let objs = {
        taskId: data.id,
        size: 25,
        page: 1,
      }
      api.reqAirDrops(objs).then(res => {
        if(res.data.list.length<=0){
          this.$message.warning('请添加模版或者导入数据')
        }else{
          this.implementTime = new Date().getTime() + 1 * 60 * 60 * 1000;
          this.implementstatu = true;
          this.implementobj = data;
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
.implementdial{
  >div{
    margin-bottom: 20px;
    &:last-child{
      // text-align: center;
      margin-top: 40px;
    }
  }

}
</style>
